import { HttpClient } from '@angular/common/http';
import { SERVER_API_URL } from '../../app.constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class PasswordService {
    constructor(http) {
        this.http = http;
    }
    save(newPassword, currentPassword) {
        return this.http.post(SERVER_API_URL + 'api/account/change-password', { currentPassword, newPassword }, { responseType: 'text' });
    }
}
PasswordService.ɵfac = function PasswordService_Factory(t) { return new (t || PasswordService)(i0.ɵɵinject(i1.HttpClient)); };
PasswordService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PasswordService, factory: PasswordService.ɵfac, providedIn: 'root' });
